import { createVanIconComponent } from "./van"

const Location = createVanIconComponent("location")
export default Location
